export const isAdmin = authState => authState && authState.isAuthenticated && authState.idToken.claims.groups && 
  authState.idToken.claims.groups.find(group => group === 'pjAdmin')

